export enum CallStatus {
    notStarted = 'notStarted',
    ongoing = 'ongoing',
}
